import React, { useContext } from 'react';
import { Link, Navigate, Outlet } from 'react-router-dom';
import { ContextData } from '../../context/Context';

export default function PrivateRoute() {
  const { accesstoken, Person, profileError, authReady, authError, restoreAuthentication } = useContext(ContextData);
  if (authReady === false) return <div style={{ padding: '48px 24px', textAlign: 'center' }}>
    <p role={authError ? 'alert' : 'status'}>{authError || 'Restoring your sign-in…'}</p>
    {authError && <button type="button" onClick={restoreAuthentication}>Retry sign-in check</button>}
  </div>;
  if (!accesstoken) return <Navigate to="/login" replace />;
  if (!Person) {
    return (
      <div style={{ padding: '48px 24px', textAlign: 'center' }}>
        <p role={profileError ? 'alert' : 'status'}>{profileError || 'Loading your account…'}</p>
        {profileError && <Link to="/login">Return to sign in</Link>}
      </div>
    );
  }
  return <Outlet />;
}
